import { Navigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { authState } from "../recoil/authState";

// club_admin_level에 따른 접근 제한 컴포넌트
export default function AdminLevelRoute({ children, allowedLevels = [] }) {
  const auth = useRecoilValue(authState);
  const clubAdminLevel = Number(auth?.user?.club_admin_level);

  // 디버깅을 위한 콘솔 로그
  console.log("AdminLevelRoute - auth:", auth);
  console.log("AdminLevelRoute - clubAdminLevel:", clubAdminLevel);
  console.log("AdminLevelRoute - allowedLevels:", allowedLevels);
  console.log(
    "AdminLevelRoute - includes check:",
    allowedLevels.includes(clubAdminLevel)
  );

  // 허용된 레벨에 포함되지 않으면 리다이렉트
  if (!allowedLevels.includes(clubAdminLevel)) {
    console.log("AdminLevelRoute - 접근 거부, 리다이렉트");
    return <Navigate to="/yb/yearBookingList" replace />;
  }

  console.log("AdminLevelRoute - 접근 허용");
  return children;
}
